module.exports = __webpack_public_path__ + "mainassets/img/btn-arrow-grey.a970cfb2.svg";